import { booleanAttribute, computed, Directive, input } from '@angular/core';
import type { ContextFamily, ContextTone } from '@quipex/shared/utils';
import { resolveTypographyClass } from './color';

@Directive({
    selector: '[qpxDisplay]',
    host: {
        '[class]': 'className()',
    },
})
export class QpxDisplay {
    public readonly context = input<
        ContextFamily | undefined,
        ContextFamily | '' | undefined
    >(undefined, {
        alias: 'qpxDisplay',
        transform: (value) => value || undefined,
    });

    public readonly tone = input<ContextTone>('default');
    public readonly decorative = input(false, { transform: booleanAttribute });

    public readonly variant = input<'xs' | 'sm' | 'md' | 'lg'>('md');

    protected readonly className = computed(() => {
        let text = '';
        switch (this.variant()) {
            case 'xs':
                text = 'text-display-xs';
                break;
            case 'sm':
                text = 'text-display-sm';
                break;
            case 'md':
                text = 'text-display-md';
                break;
            case 'lg':
                text = 'text-display-lg';
                break;
        }

        return [
            text,
            'm-0',
            resolveTypographyClass(
                this.context(),
                this.tone(),
                this.decorative()
            ),
        ].join(' ');
    });
}
